import React from 'react';

import Thumb from '../img/blogs/javascript.jpg';

const IntroductionToJavaScript = {
    id: 3, permalink: "introduction-to-javascript", thumb: Thumb, postBy: "Wasek Bellah", postDate: "Apr 28, 2020", categories: "JavaScript", title: "Introduction to JavaScript", shortDesc: "JavaScript is an object-oriented, dynamic programming language. Netscape engineer Brendan Eich created JavaScript in 1995, which was released in early 1998 with Netscape 2 (browser).", fullDesc: <>
        <h2>What is JavaScript?</h2>
        <p>JavaScript is an object-oriented, dynamic programming language. Netscape engineer Brendan Eich created JavaScript in 1995, which was released in early 1998 with Netscape 2 (browser). It was called LiveScript, but unfortunately, its name became JavaScript, due to marketing problems and capitalize the popularity.</p>

        <p>The first edition of ECMAScript was released in 1997. This 1999 standard was further developed as ECMAScript version 3. The fifth edition of the new ECMAScript was released in 2009 and the 6th major edition was released in June 2015.</p>


        <h2>Data Types:</h2>
        <p>The types in JavaScript are:</p>
        <pre className="code">
            <ul style={{ listStyleType: "inherit" }}>
                <li>String</li>
                <li>Number</li>
                <li>Object
                        <ul style={{ listStyleType: "square" }}>
                        <li>Array</li>
                        <li>Null</li>
                        <li>Date</li>
                        <li>RegExp</li>
                    </ul>
                </li>
                <li>Function</li>
                <li>Boolean</li>
                <li>Symbol <small>(new in ES2015)</small></li>
                <li>Undefined</li>
            </ul>
        </pre>


        <h2>String:</h2>
        <p><strong>Strings in JavaScript</strong> are sequences of <strong>Unicode</strong> characters.</p>

        <p>A <strong>JavaScript</strong> string stores a series of characters like <strong>"Wasek Bellah"</strong>.</p>

        <p><em><strong>String</strong> can be any text inside <strong>double or single</strong> quotes</em>:</p>
        <pre className="code">
            console.log("Wasek Bellah"); &#47;&#47; String in double quotes <br />
            console.log("Wasek Bellah"); &#47;&#47; String in single quotes <br />
            console.log("I'm a learner"); &#47;&#47; We can use quotes inside a string, as long as they don't match the quotes surrounding the string
        </pre>
        <p><strong>Expected output:</strong> <code class="output">Wasek Bellah</code>, <code class="output">Wasek Bellah</code> and <code className="output">I'm a learner</code></p>


        <h2>Number:</h2>
        <p><strong>Numbers in JavaScript</strong> are <strong>"double-precision 64-bit format IEEE 754 values"</strong>, according to the <strong>spec</strong>.</p>

        <p><strong>JavaScript</strong> has only one type of <strong>number</strong>.</p>

        <p><em><strong>Numbers</strong> can be written <strong>with or without decimals</strong></em>:</p>
        <pre className="code">
            console.log(21); &#47;&#47; A number without decimals <br />
            console.log(21.43); &#47;&#47; A number with decimals
        </pre>
        <p><strong>Expected output:</strong> <code class="output">21</code> and <code className="output">21.43</code></p>


        <h2>Object:</h2>
        <p><strong>JavaScript objects</strong> can be thought of as a <strong>general collection of name-value pairs</strong>.</p>

        <pre className="code">
            var person = &#123; name: "Wasek Bellah", age: 21, favoriteColor: "blue" &#125;; <br />
            console.log(person.name); <br />
            console.log(person["age"]); &#47;&#47; Bracket notation use: when object property has two or more words with whitespace
        </pre>
        <p><strong>Expected output:</strong> <code class="output">Wasek Bellah</code> and <code class="output">21</code></p>

        <p><em>Update <strong>object</strong> value</em>:</p>
        <pre className="code">
            var person = &#123; name: "Wasek Bellah", age: 21, favoriteColor: "blue" &#125;; <br />
            person.favoriteColor = "Green"; <br />
            console.log(person);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">&#123;name: 'Wasek Bellah', age: 21, favoriteColor: 'Green' &#125;</code></p>

        <p><em>Delete <strong>object</strong> property</em>:</p>
        <pre className="code">
            var person = &#123; name: "Wasek Bellah", age: 21, favoriteColor: "blue" &#125;; <br />
            delete person.favoriteColor; <br />
            console.log(person);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">&#123; name: 'Wasek Bellah', age: 21 &#125;</code></p>


        <h2>Array:</h2>
        <p><strong>JavaScript arrays</strong> are used to store <strong>multiple</strong> values in a <strong>single variable</strong>.</p>

        <p>An <strong>array</strong> can hold many values under a <strong>single name</strong>, and you can access the values by referring to an <strong>index number</strong>.</p>

        <pre className="code">
            var country = ["Afghanistan", "Bangladesh", "Bhutan", "India", "Nepal", "Pakistan", "Sri-Lanka", "Hong-Kong" ]; <br />
            console.log(country[1]); <br />
            console.log(country.length);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">Bangladesh</code> and <code class="output">8</code></p>

        <p><em>The following example also creates an <strong>Array</strong>, and assigns values to it</em>:</p>
        <pre className="code">
            var country = new Array ("Afghanistan", "Bangladesh", "Bhutan", "India", "Nepal", "Pakistan", "Sri-Lanka", "Hong-Kong" );
        </pre>


        <h2>Null:</h2>
        <p>In <strong>JavaScript</strong> <code>null</code> is <strong>"nothing"</strong>. It is supposed to be something that doesn't exist. and <code>null</code> is an object.</p>

        <pre className="code">
            console.log(typeof (null));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">object</code></p>

        <p><em>You can empty an <strong>object</strong> by setting it to <code>null</code></em>:</p>
        <pre className="code">
            var name = "Wasek Bellah"; <br />
            var name = null; <br />
            console.log(name);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">null</code></p>


        <h2>Function:</h2>
        <p>A <strong>JavaScript function</strong> is a block of code designed to perform a particular task.</p>

        <p>A <strong>JavaScript function</strong> is executed when "something" invokes it (calls it).</p>

        <pre className="code">
            function fun(a, b)&#123; <br />
                &nbsp; return a + b <br />
            &#125; <br />
            console.log(typeof (fun));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">function</code></p>

        <p>A <strong>JavaScript function</strong> is defined with the <strong>function keyword</strong>, followed by a <strong>name</strong>, followed by <strong>parentheses()</strong>.</p>

        <p><strong>Function names</strong> can contain <strong>letters, digits, underscores, and dollar signs</strong> (same rules as variables).</p>

        <p>The <strong>parentheses</strong> may include <strong>parameter names</strong> separated by <strong>commas(,)</strong>: (parameter1, parameter2, ...)</p>

        <p>The code to be executed, by the <strong>function</strong>, is placed inside <strong>curly brackets</strong>: &#123;&#125;</p>

        <pre className="code">
            function name(parameter1, parameter2, parameter3) &#123; <br />
                &nbsp; &#47;&#47; code to be executed <br />
            &#125;
        </pre>

        <p><strong>Function parameters</strong> are listed inside the <strong>parentheses()</strong> in the <strong>function</strong> definition.</p>

        <p><strong>Function arguments</strong> are the values received by the <strong>function</strong> when it is invoked.</p>

        <p>Inside the <strong>function</strong>, the <strong>arguments(the parameters)</strong> behave as <strong>local variables</strong>.</p>


        <h2>Boolean:</h2>
        <p><strong>JavaScript booleans</strong> can have one of two values: <strong>true or false</strong>.</p>

        <p><em>You can use the <code>Boolean()</code> function to find out if an expression is <strong>true or false</strong></em>:</p>
        <pre className="code">
            console.log(Boolean(15 &rsaquo; 9)); <br />
            console.log(Boolean(15 &lsaquo; 9)); <br />
            console.log(Boolean()); <br />
            console.log(Boolean("Wasek Bellah")); <br />
            console.log(Boolean(""));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">true</code>, <code class="output">false</code>, <code class="output">false</code>, <code class="output">true</code> and <code className="output">false</code></p>


        <h2>Undefined:</h2>
        <p>In <strong>JavaScript</strong>, a variable without a value, has the value <code>undefined</code>. The type is also <code>undefined</code>.</p>

        <pre className="code">
            var myVar; &#47;&#47; Empty Variable <br />
            console.log(myVar);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">undefined</code></p>

        <p><em>Any variable can be emptied, by setting the value to <code>undefined</code>. The type will also be <code>undefined</code></em>:</p>
        <pre className="code">
            var myVar = undefined; <br />
            console.log(myVar);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">undefined</code></p>
    </>
};
export default IntroductionToJavaScript;